import { nodesFlux, useEditorSelector } from '@candulabs/craft';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import Node from 'craft/components/Node';
import { useNodeContext } from 'craft/hooks';
import { Resolver } from 'craft/types';

const StyledHr = styled.hr`
  background-color: var(--color-lines);
  border: none;
  height: 1px;
`;

// a dummy resolver for a Spacing
export const Spacing: Resolver = () => {
  const { id } = useNodeContext();
  const selector = useMemo(() => nodesFlux.selectors.getNodeProps(id), [id]);
  const props = useEditorSelector(selector);

  return (
    <Node>
      <StyledHr {...props} />
    </Node>
  );
};

Spacing.craft = {
  name: 'Spacing',
};
